import { FormulaireRdv } from '@components/formulaire-rdv/models';
import { Block } from '@shared/models';

export const formulaireRdvMock: Block<FormulaireRdv> = {
  type: 'formulaire-rdv',
  data: {
    title: {
      text: `Mes coordonnées`,
      as: 'span',
    },
    legalNoticeHtml: `Pour connaître l’utilisation que nous faisons des données collectées par ce formulaire et exercer vos droits sur vos données personnelles, notamment en matière d’accès et de suppression, veuillez consulter <strong><a href="/charte" />notre charte de confidentialité</a></strong>.`,
    cta: {
      label: `Je valide mon rendez-vous`,
      url: 'mock-tunnel-confirmation',
    },
    gtmConfigBtnForm: {
      event: 'confirm_rdv_tunnel',
      group: 'rdv',
      description: 'rendez-vous valide',
      context: 'chargement page validation rdv',
    },
  },
};
